import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, DatePicker, Radio, Card, Input, Popconfirm, Checkbox, Empty } from 'antd';
import React, { useEffect, useState } from 'react';
import { DownloadOutlined, } from '@ant-design/icons';
import axios from 'axios';
const PreviewImgModal = (props) => {
    const handleDownload = () => {
        // console.log(props.file);
        // console.log(props.file.file_id);
        axios
            .get('/cramSchool/api/media/classify_structure_type_file_download', {
                responseType: 'blob',
                params: {
                    file_id: props.file.file_id
                }
            })
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `${props.file.file_client_name}`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
    }
    return (
        <Modal
            open={props.modal_img}
            // onOk={hideModal}
            onCancel={e => props.set_modal_img(false)}
            footer={false}
            width={600}
            style={{ padding: '20px' }}
        >
            <Row justify={'end'} style={{ paddingRight: '20px' }} gutter={[8, 16]}>
                {props.download == true ? <>
                    <Col style={{ paddingRight: '40px', paddingTop: '10px' }}>
                        <Button type='primary' style={{ display: "inline-flex", alignItems: "center" }} icon={<DownloadOutlined />}
                            // onClick={e => window.open(`${axios.defaults.baseURL}/cramSchool/api/media/classify_structure_type_file_download?file_id=${props.file_id}`)}
                            onClick={handleDownload}
                        >檔案下載</Button>
                    </Col>
                </> : null}

                <Col span={24}>
                    {/* <Row justify={'center'}>
                        <Col> */}
                    <img width={'100%'} height={'auto'} src={props.img}></img>
                    {/* </Col>
                    </Row> */}
                </Col>
            </Row>

        </Modal>
    )
}
export default PreviewImgModal;